import { type AnyValueStatus, type RequestStatus, getRequestStatusValue } from "@suse-o11y/request-status";
import { type OperatorFunction, scan } from "@suse-o11y/rxjs";

/**
 * Works like rxjs scan operator, but on request status values. Error and Loading statuses are still propagated when occur
 *
 * @deprecated avoid using anything related to rxjs
 */
export const scanObservableValue = <E, T, R, M = unknown>(
	accumulator: (acc: R, value: T) => R,
	seed: AnyValueStatus<E, R, M>,
): OperatorFunction<RequestStatus<E, T, M>, RequestStatus<E, R, M>> => {
	let lastAccValueStatus: AnyValueStatus<E, R, M> = seed;
	return scan((accStatus: RequestStatus<E, R, M>, status: RequestStatus<E, T, M>) => {
		const acc = getRequestStatusValue(lastAccValueStatus) as R;
		const value = getRequestStatusValue(status);
		if (value != null) {
			lastAccValueStatus = { ...lastAccValueStatus, ...status, value: accumulator(acc, value) } as AnyValueStatus<
				E,
				R,
				M
			>;
			return lastAccValueStatus;
		}
		return status as RequestStatus<E, R, M>;
	}, lastAccValueStatus);
};
